import { cn } from 'common/utils';
import React from 'react';

const Filter = ({ size = 24, color = '#8D91A0', onClick }) => {
  return (
    <div className={cn({ 'cursor-pointer': onClick })}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
      >
        <g clipPath='url(#clip0_694_6321)'>
          <path d='M24 0H0V24H24V0Z' fill='white' fillOpacity='0.01' />
          <path
            d='M3 4.5L10.2 12.9089V19.2222L13.8 21V12.9089L21 4.5H3Z'
            stroke={color}
            strokeWidth='1.6'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_694_6321'>
            <rect width='24' height='24' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default Filter;
